import React from 'react'
import Features from './Features'
import Header from './Header'
import ImgAlbum from './ImgAlbum'

export default function MainPage() {
  return (
    <>
       <Header/>
       <Features/>
  
    
    </>
  )
}
